import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdatedColumns } from 'src/app/interfaces/updatedColumns';
import { URL } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class TableVisualizationService {
  private readonly http = inject(HttpClient);

  // Get The data of the table based on
  getTableData(tableId: number, limit: number, offset: number, jsonData: any): Observable<any> {
    const params = {
      limit,
      offset,
      jsonData
    };

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params
    };

    return this.http.get<any>(`${URL.url}${URL.table}${tableId}`, options);
  }

  // PUT : it's for updating the columns data
  updateTableData(tableId: number, updatedColumns: UpdatedColumns[]): Observable<any> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(updatedColumns);

    return this.http.put(`${URL.url}${URL.table}${tableId}/column`, body, { headers });
  }

  // DELETE : it's for deleting the table
  deleteTable(tableId: number): Observable<any> {
    return this.http.delete(`${URL.url}${URL.table}${tableId}`);
  }
}
